// extracted by mini-css-extract-plugin
module.exports = {"button":"SettingsButton_button__lT2pr","button__action":"SettingsButton_button__action__3EPTB"};